
import { signalStore, withState, withMethods, withComputed, patchState } from '@ngrx/signals';
import { computed } from '@angular/core';
import { SortUtil } from 'ev-grid-table';
import { FilterOverview, FilterType, SortOption } from 'src/models/shared/filter.model';

export enum FavoriteListStates {
    Overview,
    NewCart,
    Details
}


type OverviewFavoriteListsState = {
    state: FavoriteListStates;
    selectedId: number,
    overview: FilterOverview[];
    filterType: FilterType
    activeMenu: number;
    sortOption?: SortOption;
};

const initialState: OverviewFavoriteListsState = {
    state: FavoriteListStates.Overview,
    selectedId: 0, 
    overview: [],
    filterType: FilterType.Market,
    activeMenu: -10,
    sortOption: {
        name: 'Opprettet dato',
        prop: 'createdTimestamp',
        desc: true,
        type: "date"
    } as SortOption 
};


export const OverviewFavoriteListsStore = signalStore(
    { providedIn: 'root' },
    withState(initialState),
    withComputed((store) => ({
        // True when an existing list is open (Details) or a new one is being created (NewCart).
        isFavoriteListOpen: computed(() => store.state() !== FavoriteListStates.Overview),
    })),
    withMethods((store) => ({
        load(lists: FilterOverview[], filterType: FilterType): void {
            const prop = store.sortOption().prop as keyof FilterOverview;
            const sorted = lists.sort((a, b) => SortUtil.sortBySortType(a[prop], b[prop], store.sortOption()));
            patchState(store, { overview: [...sorted], filterType });
        },
        addToOverview(list: FilterOverview): void {
            patchState(store, (state) => ({ overview: [...state.overview, list] }));
        },
        removeFromOverview(id: number): void {
            patchState(store, (state) => ({ overview: state.overview.filter(list => list.id !== id) }));
        },
        updateListInOverview(updatedList: FilterOverview): void {
            patchState(store, (state) => ({ overview: state.overview.map(list => list.id === updatedList.id ? updatedList : list) }));
        },
        updateState(state: FavoriteListStates): void {
            patchState(store, { state });
        },
        setSelected(selectedId: number | string): void {
            patchState(store, { selectedId: Number(selectedId) });
        },
        setActiveMenu(activeMenu: number | string): void {
            patchState(store, { activeMenu: Number(activeMenu) });
        },
        closeMenu(): void {
            patchState(store, { activeMenu: -10 });
        },
        clear(): void {
            patchState(store, initialState);
        }
    }))
);